export default __webpack_public_path__ + "static/media/AdobeStock_249444411.bfd27559.jpg";